import Alert from "./Alert.js";
import Accordion from "./Accordion.js";
import { getAutocompleteStyles, getAutocompleteWithIconStyles } from "./Autocomplete.js";
import Avatar from "./Avatar.js";
import Badge from "./Badge.js";
import Banner from "./Banner.js";
import Breadcrumb from "./Breadcrumb.js";
import Button from "./Button.js";
import Checkbox from "./Checkbox.js";
import Collapsible from "./Collapsible.js";
import Form from "./Form.js";
import FormError from "./FormError.js";
import FormLabel from "./FormLabel.js";
import Heading from "./Heading.js";
import InfoBox from "./InfoBox.js";
import Input from "./Input.js";
import Link from "./Link.js";
import Modal from "./Modal.js";
import Popover from "./Popover.js";
import Progress from "./Progress.js";
import Radio from "./Radio.js";
import { getSelectStyles } from "./Select.js";
import Spinner from "./Spinner.js";
import Switch from "./Switch.js";
import Text from "./Text.js";
import Textarea from "./Textarea.js";
import Tabs from "./Tabs.js";
import Tag from "./Tag.js";
const components = {
    Alert: Alert,
    Accordion,
    Avatar,
    Badge,
    Banner,
    Breadcrumb,
    Button,
    Checkbox,
    Form,
    FormError,
    FormLabel,
    Heading,
    Radio,
    Input,
    Link,
    Modal,
    Popover,
    Progress,
    InfoBox,
    Spinner,
    Switch,
    Text,
    Textarea,
    Collapsible,
    Tag,
    Tabs,
    getAutocompleteStyles,
    getAutocompleteWithIconStyles,
    getSelectStyles,
};
export default components;
